<!-- 
  IMPORTANT: This component is meant to be used inside a container of blocks.$derived

  If you want Text + Label independent of a block, use TextWithLabel.svelte
 -->
<script>
  import TextLabel from "#lib/TextLabel.svelte";
  import Text from "#lib/Text.svelte";

  let {
    block,
    /** @type {string} name of the field to edit (required for Selection API) */
    field_name,
    is_editing,
    /** @type {string|function} text or svelte snippet */
    label,
    placeholder,
    icon,
    variant,
    /** @type {'start'|'top'} */
    placement,
    class: css_class
  } = $props();

</script>

<div class="labelled-text {css_class}">
  {#if is_editing && (label || icon)}
    <TextLabel {icon} {placement}>
      {#if typeof label === 'string'}
        {label}
      {:else if typeof label === 'function'}
        {@render label()}
      {/if}
    </TextLabel>
  {/if}
  <Text
    {variant}
    editable={is_editing}
    bind:content={block[field_name]}
    {placeholder}
    {field_name}
  />
</div>

<style>
  .labelled-text {
    position: relative;
  }
</style>